<template>
  <div class="body-width" >
        <div class="div-top3">
           <div class="div-margin " >
          <img src="../../../../assets/images/hhmnq/01.jpg"/>
        </div>
        </div>
  <!-- <div class="div-row pr-padding-top news-Medium-24" >  
     航海模拟器系列产品
  </div> -->
<!-- <div class="div-row">  
 <p class="indentation">航海模拟器系列产品包括全任务船舶操纵模拟器、雷达模拟器、ECDIS模拟器、GMDSS模拟器，满足STCW公约、《中华人民共和国海船船员培训大纲》、《中华人民共和国海船船员适任评估规范》中关于船员培训与评估的要求，其中全任务船舶操纵模拟器通过了挪威船级社等级（A级）认证及中国船级社认证。</p>
 <p class="indentation">航海模拟器系列产品满足多种业务培训需求，如船员培训、引航员培训、VTS操作员培训、GMDSS无线电操作员培训，以及其它特殊业务培训（拖轮作业、渔业操作、冰区航行、内河航行、游艇操纵、溢油应急、搜寻救助），还可用于港航工程论证、智能船用设备验证等科学研究。</p>
  </div>
<div  class="div-row" >  
      <div class="  div-top"  >
        <div class="div-margin " >
          <img src="../../../../assets/images/product1.png" />
        </div>
        <div class="div-top3">
          全任务船舶操纵模拟器
        </div>
      </div>
      <div class=" div-top1  box2">
        <div class="div-margin " >
          <img src="../../../../assets/images/product2.png" />
        </div>
        <div class="div-top3">
         雷达模拟器
        </div>
      </div>
</div>
<div  class="div-row" >  
      <div class=" div-top" >
        <div class="div-margin ">
          <img  src="../../../../assets/images/product3.png" />
        </div>
        <div class="div-top4">
        ECDIS模拟器
        </div>
      </div>
      <div class=" div-top1  " >
        <div class="div-margin " >
          <img src="../../../../assets/images/product4.png" />
        </div>
        <div class="div-top4">
         GMDSS模拟器
        </div>
      </div>
</div> -->
</div>
</template>
<script>
 export default {
    data() {
      return {
        isflag1: true,
        isflag2: false
      };
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll)
    },
    methods: {
      handleScroll() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (parseInt(scrollTop) >= 300 && parseInt(scrollTop) < 1200) {
          // alert(scrollTop)
          this.isflag2 = true;
        }

      },
      destroyed() {
        window.removeEventListener('scroll', this.handleScroll)
      },
    },
  };

</script>

<style scoped>
  .div-top {
    float: left;
    padding-left: 40px;

  }
    .div-top1 {
    float: right;
      padding-right: 40px;

  }
    .div-top3 {
     margin-top: 10px;
     margin-bottom: 40px;
     color: #b6b6b6;
  }
     .div-top4 {
    margin-top: 10px;
     color: #b6b6b6;
  }
   .div-row {
clear:both;
  } 


/* .xz {
  display:block;
  animation: roate 2s;
  animation-fill-mode: forwards;
  animation-direction: alternate;
  }
  
  @keyframes roate {
  from {
  transform: rotate(0deg);
  width: 50px;
  height: 50px;
  }
  
  to {
  transform: rotate(360deg);
  width: 100%;
  height: 100%;
  
  } */

</style>


// WEBPACK FOOTER //
// src/components/contentcoms/prodecutcontentcoms/hhmnqxlcp/productcp.vue